// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import { GET_DANH_SACH_KHO_DONE } from './constant';

export type DanhSachKhoHangState = {
  listKhoHang: any;
};

const initState: DanhSachKhoHangState = {
  listKhoHang: [],
};

const cauHinhDiaChiReducer = (
  state = initState,
  action: ActionType,
): DanhSachKhoHangState => {
  return produce(
    state,
    (draftState: DanhSachKhoHangState): DanhSachKhoHangState => {
      switch (action.type) {
        case GET_DANH_SACH_KHO_DONE:
          draftState.listKhoHang = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};

export default cauHinhDiaChiReducer